import React, { Component } from 'react';

class LoadingState extends React.Component {

  renderImage(loadingType) {
    if(loadingType == "submitted") {
      return (<div className="margin-middle text-center">
                <img src="/assets/icons/alerts/success-icon.svg" width="30px" height="30px" />
              </div>);
    } else if(loadingType == "error"){
      return (<div className="margin-middle text-center">
                <img src="/assets/icons/alerts/error-icon.svg" width="30px" height="30px" />
              </div>);
    } else {
      return (<div className="spinner margin-middle text-center muted cs-spinner">
                <i className="fas  fa-circle-notch fa-spin fa-2x fa-fw"></i>
              </div>);
    }
  }

  render() {
    let { text, loadingType } = this.props;
    return(
      <div className="cs-light-gray-box br4 p3 cs-new-loading-state">
        <div className="background-white br5 p3 border-color-gray spinner-wrapper">
          {this.renderImage(loadingType)}
        </div>
        <div className="loading-text pt2 text-center">{text}</div>
      </div>
    );
  }
}

export default LoadingState;
